import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TouchLogin from "./components/LoginPage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import VerifyCodePage from "./components/VerifyCodePage";
import ResetPasswordSentPage from "./components/ResetPasswordSentPage";
import RegisterPage from "./components/RegisterPage";
import DashboardPage from "./components/DashboardPage";
import IdentityPage from "./components/IdentityPage";
import PlansPage from "./components/PlansPage";
import WalletPage from "./components/WalletPage";
import ChallengesPage from "./components/ChallengesPage";
import CompetitionsPage from "./components/CompetitionsPage";
import CompetitionCurrentPage from "./components/CompetitionCurrentPage";
import MyCompetitionsPage from "./components/MyCompetitionsPage";
import OrdersPage from "./components/OrdersPage";
import WithdrawPage from "./components/WithdrawPage";
import ProfilePage from "./components/ProfilePage";
import TicketsPage from "./components/TicketsPage";
import NotificationsPage from "./components/NotificationsPage";
import CertificatesPage from "./components/CertificatesPage";
import AffiliatePage from "./components/AffiliatePage";
import AnalysisPage from "./components/AnalysisPage";
import CartPage from "./components/CartPage";
import QrDepositPage from "./components/QrDepositPage";
import TicketDetailPage from "./components/TicketDetailPage";
import DownloadsPage from "./components/DownloadsPage";
import PaymentSuccessPage from "./components/PaymentSuccessPage";
import PaymentCancelPage from "./components/PaymentCancelPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<TouchLogin />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/verify-code" element={<VerifyCodePage />} />
        <Route path="/reset-password-sent" element={<ResetPasswordSentPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/identity" element={<IdentityPage />} />
        <Route path="/challenges" element={<ChallengesPage />} />
        <Route path="/competitions" element={<CompetitionsPage />} />
        <Route path="/competitions/current" element={<CompetitionCurrentPage />} />
        <Route path="/competitions/mine" element={<MyCompetitionsPage />} />
        <Route path="/competitions/details" element={<Navigate to="/challenges" replace />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/withdraw" element={<WithdrawPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/certificates" element={<CertificatesPage />} />
        <Route path="/affiliate" element={<AffiliatePage />} />
        <Route path="/analysis/:accountNumber" element={<AnalysisPage />} />
        <Route path="/analysis" element={<AnalysisPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/qr" element={<QrDepositPage />} />
        <Route path="/crypto-payment/:paymentId" element={<QrDepositPage />} />
        <Route path="/payment/success/*" element={<PaymentSuccessPage />} />
        <Route path="/payment/cancel/*" element={<PaymentCancelPage />} />
        <Route path="/tickets/:id" element={<TicketDetailPage />} />
        <Route path="/downloads" element={<DownloadsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
